import { render, staticRenderFns } from "./BaseChannelCard.vue?vue&type=template&id=4fedda84&scoped=true"
import script from "./BaseChannelCard.vue?vue&type=script&lang=js"
export * from "./BaseChannelCard.vue?vue&type=script&lang=js"
import style0 from "./BaseChannelCard.vue?vue&type=style&index=0&id=4fedda84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fedda84",
  null
  
)

export default component.exports